import React, { useState } from "react";
import {
  ItemListadoMascotasReservas,
  useListarMascotasReservasGuarderia,
} from "../../../../services/reservasGuarderiaServicios";
import TableSection from "./TableSection";
import ServerErrorModal from "../../../organisms/ServerErrorModal";
import { Model } from "../Model";
import Tarifas from "../Tarifas/Tarifas";
import { Row, Stack } from "react-bootstrap";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SuccessButton from "../../../organisms/SuccessButton";
import { useWizard } from "../../../../hooks/wizard";

function SeleccionMascota({ model }: { model: Model }) {
  const { data, isLoading, isSuccess, error } =
    useListarMascotasReservasGuarderia();

  const { avanzar, avanza } = useWizard();

  const [newModel, setNewModel] = useState(model);

  const puedeAvanzar = !!newModel.idMascota;

  const onMascotaRowClick = (
    itemListadoMascotaReservas: ItemListadoMascotasReservas
  ) => {
    setNewModel((prevModel) => {
      const updatedModel: Model = {
        ...prevModel,
        idMascota: itemListadoMascotaReservas.id,
        idPropietario: itemListadoMascotaReservas.idPropietario,
        nombreMascota: itemListadoMascotaReservas.nombre,
        nombresPropietario: itemListadoMascotaReservas.nombresPropietario,
        fechasReservadasAnteriormente:
          itemListadoMascotaReservas.fechasReservadas,
      };
      return updatedModel;
    });
  };

  if (error) {
    return <ServerErrorModal />;
  }

  if (avanza) {
    return <Tarifas model={newModel} />;
  }

  return (
    <Stack gap={2} className="p-2">
      <section className="d-flex gap-2 mx-3">
        <h5>Mascota seleccionada: </h5>
        {!!newModel.nombreMascota && <h5>{newModel.nombreMascota}</h5>}
      </section>
      <TableSection
        title={"Seleccionar mascota"}
        items={data || []}
        onRowClick={onMascotaRowClick}
        isLoading={isLoading}
        isSuccess={isSuccess}
      />
      <Row className="mb-2 justify-content-end">
        <SuccessButton
          type={"button"}
          style={{ width: "fit-content" }}
          disabled={!puedeAvanzar}
          onClick={avanzar}
        >
          Siguiente <ArrowForwardIcon sx={{ fontSize: 20 }} />
        </SuccessButton>
      </Row>
    </Stack>
  );
}

export default SeleccionMascota;
